'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCloudUpload, iconCloudUploadTag } from '@ni/nimble-components/dist/esm/icons/cloud-upload';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCloudUpload };
export { iconCloudUploadTag };
export const NimbleIconCloudUpload = wrap(IconCloudUpload);